import request from 'graphql-request';
import { graphql } from '../../../gql/api-wr-tools/gql';
import type {
  BrainToolsHomeworkHelperNextMutation,
  BrainToolsHomeworkHelperNextMutationVariables,
} from '../../../gql/api-wr-tools/graphql';
import { IResponseData } from '../../../typings/common';
import { Endpoint } from '../../endpoint';

const mutation = graphql(/* GraphQL */ `
  mutation BrainToolsHomeworkHelperNext(
    $clientHash: String!
    $chatIdHash: String!
    $instructions: String!
  ) {
    brainToolsHomeworkHelperNext(
      clientHash: $clientHash
      chatIdHash: $chatIdHash
      instructions: $instructions
    ) {
      status {
        code
        message
      }
      generatedText
      responseGenIdHash
    }
  }
`);

interface IHomeworkHelpNextResult {
  generatedText: string | null;
  responseGenIdHash: string | null;
}

export const generateNextHomeworkHelp = async (
  payload: BrainToolsHomeworkHelperNextMutationVariables
): Promise<IResponseData<IHomeworkHelpNextResult>> => {
  const response = await request<
    BrainToolsHomeworkHelperNextMutation,
    BrainToolsHomeworkHelperNextMutationVariables
  >(Endpoint.GRAPHQL_WRITING_TOOLS_AI_CALL, mutation, payload);

  const {
    brainToolsHomeworkHelperNext: { generatedText, responseGenIdHash, status },
  } = response;

  const result: IHomeworkHelpNextResult = {
    generatedText: generatedText ?? null,
    responseGenIdHash: responseGenIdHash ?? null,
  };

  return {
    data: result,
    status: status.code,
    message: status.message,
  };
};
